const editStageModalStyles = (theme) => ({
  dialogField: {
    marginBottom: theme.spacing(2),
  },
})

export default editStageModalStyles
